import { AUTHOR, MONICA, BOOK } from "../../data/content";
import { Reveal, motion } from "../../lib/motion";
import { SectionLabel, Ornament } from "./ui";

export function AuthorSection() {
  return (
    <section id="author" className="relative py-24 sm:py-36 bg-secondary" data-testid="author-section" data-section="author" data-section-label="Autrice">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-1">
          <Reveal>
            <div className="relative max-w-sm mx-auto lg:mx-0">
              <div className="absolute -inset-4 rounded-lg blur-2xl opacity-30" style={{ background: "radial-gradient(circle, rgba(170,134,86,0.4), transparent 70%)" }} />
              <motion.img
                initial={{ opacity: 0, scale: 1.05 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                src={BOOK.coverUrl}
                alt="Maria Gioia Mosca — creator of Self Doubling"
                className="relative w-full rounded-md ring-1 ring-[var(--gold-line)] object-cover"
                style={{ filter: "grayscale(0.2) contrast(1.05)" }}
                data-testid="author-portrait"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-2">
          <Reveal><SectionLabel num="06">About the Author</SectionLabel></Reveal>
          <Reveal>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl gold-gradient-text leading-none">
              MARIA GIOIA MOSCA
            </h2>
          </Reveal>
          <Reveal delay={0.05}>
            <p className="font-editorial italic text-xl text-gold-light mt-3">{AUTHOR.role}</p>
          </Reveal>
          <div className="mt-8 space-y-5 max-w-xl">
            {AUTHOR.bio.map((p, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <p className="font-body font-light text-secondary leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-10 max-w-xl" data-testid="author-memberships">
              <p className="label mb-4">Member of</p>
              <ul className="space-y-3">
                {AUTHOR.memberships.map((m) => (
                  <li
                    key={m.acronym}
                    className="flex flex-wrap items-center gap-x-4 gap-y-2"
                    data-testid={`membership-${m.acronym}`}
                  >
                    <span className="font-body font-light text-secondary text-sm sm:text-base leading-relaxed flex-1 min-w-0">
                      {m.full}
                    </span>
                    <span className="font-display text-cream text-sm tracking-widest gold-border px-3 py-1 rounded-full whitespace-nowrap">
                      {m.acronym}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export function MonicaSection() {
  return (
    <section className="relative py-20 sm:py-28 bg-primary" data-testid="monica-section" data-section="monica" data-section-label="Monica">
      <div className="max-w-4xl mx-auto px-5 sm:px-10 text-center">
        <Ornament className="mb-8" />
        <p className="label mb-4">In Gratitude</p>
        <h3 className="font-display text-2xl sm:text-3xl text-cream">{MONICA.name}</h3>
        <p className="font-editorial italic text-lg text-gold-light mt-2">{MONICA.role}</p>
        <p className="font-body font-light text-secondary max-w-2xl mx-auto mt-6 leading-relaxed">
          {MONICA.bio}
        </p>
      </div>
    </section>
  );
}
